export const ComercialStatusBadge = ({ status, statusTypes }) => {
  const st = (statusTypes || []).find(s => s.name === status);
  const label = st ? st.label : status;
  const color = st ? st.color : "bg-slate-100 text-slate-800 border-slate-200";
  return <span className={`px-2 py-1 text-xs font-medium border rounded ${color}`} data-testid={`comercial-status-${status}`}>{label}</span>;
};
